import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Instance from 'highcharts'
import Highcharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './HorizontalBarChart.styles'

/**
 * The HorizontalBarChart's component.
 */
const HorizontalBarChart = props => {
  const { categories, data, dataLabelFormatter, id, labelFormatter, backgroundColor } = props
  const theme = useTheme()
  const options = {
    accessibility: { enabled: false },
    chart: { height: 500, type: 'bar' },
    plotOptions: {
      bar: { minPointLength: 5 },
      series: {
        dataLabels: { enabled: true },
        pointWidth: 35
      }
    },
    series: [
      {
        data,
        dataLabels: [
          {
            allowOverlap: true,
            backgroundColor: backgroundColor === undefined ? theme.palette.brand.gray3 : backgroundColor,
            formatter: dataLabelFormatter,
            padding: 10,
            style: { color: theme.palette.brand.black1, fontSize: '11px', textOutline: 'none' },
            x: 10
          }
        ]
      }
    ],
    title: { text: undefined },
    tooltip: { enabled: false },
    xAxis: {
      categories,
      endOnTick: true,
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
      labels: { formatter: labelFormatter },
      min: 0,
      startOnTick: false
    },
    yAxis: {
      title: { text: '' }
    }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <Highcharts highcharts={Instance} options={options} />
      </Root>
    </>
  )
}

HorizontalBarChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      orders: PropTypes.number,
      y: PropTypes.number
    })
  ).isRequired,
  dataLabelFormatter: PropTypes.func,
  id: PropTypes.string.isRequired,
  labelFormatter: PropTypes.func,
  backgroundColor: PropTypes.string
}

export default HorizontalBarChart
